module.exports = __webpack_public_path__ + "img/medium.58656b6e.svg";